import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';
import { getComicsByCategory } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeCategory = categories.find((c) => c.id === slug);
  const categoryComics = slug ? getComicsByCategory(slug) : [];
  const displayName = activeCategory?.name || slug || '';

  const pageTitle = `${displayName}韩漫_${displayName}韩国漫画_免费${displayName}韩漫在线观看`;
  const pageDesc = `韩国漫画网${displayName}韩漫分类，提供${categoryComics.length}部免费${displayName}韩国漫画在线观看，每日更新，高清画质，流畅阅读体验。`;

  return (
    <>
      <ScrollToTop />
      <title>{pageTitle} - 韩国漫画网</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content={`${displayName}韩漫,${displayName}韩国漫画,免费${displayName}漫画,韩漫在线观看,韩国漫画网`} />
      <link rel="canonical" href={`https://nextdiscover.cn/category/${slug}`} />
      <meta property="og:title" content={`${pageTitle} - 韩国漫画网`} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://nextdiscover.cn/category/${slug}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${pageTitle} - 韩国漫画网`} />
      <meta name="twitter:description" content={pageDesc} />

      <Navbar />
      <main className="pt-24 pb-14 min-h-screen">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '分类浏览', href: '/category/romance' },
              { label: `${displayName}韩漫` },
            ]}
          />

          <div className="mt-6">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {displayName}韩漫
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              {activeCategory?.description || `浏览${displayName}类型的韩国漫画作品`}
            </p>
          </div>

          <div className="mt-6 flex items-center gap-2 flex-wrap overflow-x-auto pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  cat.id === slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600 border border-background-200/70'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="mt-8">
            {categoryComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
                {categoryComics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/article/${comic.id}`}
                    className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200"
                  >
                    <div className="relative overflow-hidden aspect-[3/4]">
                      <img
                        src={comic.cover}
                        alt={`${comic.title} - ${comic.categoryName}韩漫在线观看`}
                        title={`${comic.title} - 韩国漫画网${comic.categoryName}分类`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      />
                      <div className="absolute top-2 left-2">
                        <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
                          {comic.rating}
                        </span>
                      </div>
                      {comic.status === 'completed' && (
                        <div className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
                          完结
                        </div>
                      )}
                    </div>
                    <div className="p-3 md:p-4">
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                        {comic.title}
                      </h3>
                      <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
                      <div className="mt-2 flex items-center justify-between">
                        <span className="text-xs text-foreground-400">{comic.chapters} 话</span>
                        <span className={`text-xs ${
                          comic.status === 'completed' ? 'text-accent-600' : 'text-primary-600'
                        }`}>
                          {comic.status === 'completed' ? '已完结' : '连载中'}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画作品</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}